import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, of } from 'rxjs';
import { AvatarService } from "./services/avatar.service";

@Component({
  selector: 'core-plugin-lib-user-avatar',
  imports: [CommonModule],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAvatarComponent implements OnInit {

	private readonly avatarService = inject(AvatarService);

	@Input() email: string | undefined;
	@Input() name: string | undefined;
	@Input() internalAvatarUrl: string | null | undefined; // URL to internal avatar
	@Input() size: number = 40;

	avatarUrl$: Observable<string | null> = of(null);
	altText: string = 'User avatar';

	ngOnInit(): void {
		this.altText = this.name ? `${this.name}'s avatar` : 'User avatar';

		if (!this.email) {
			return;
		}

		// Get avatar with priority: internal > gravatar (if enabled) > null
		this.avatarUrl$ = this.avatarService.getAvatarUrl(
			this.email,
			this.internalAvatarUrl,
			this.size
		);
	}

	getInitials(): string {
		return this.avatarService.computeInitials(this.name, this.email);
	}

	onImageError(): void {
		console.debug('Failed to load avatar image');
	}
}
